<ion-card class="profilebody">
  <!-- header -->
  <ion-row class="header-row">
    <h3>{{ data.edit ? CONSTANTS.EDIT_HEADER : CONSTANTS.HEADER }}</h3>
    <img [src]="IMAGES.CLOSE" alt="close" (click)="close(false)" />
  </ion-row>

  <div class="card-content">
    <form [formGroup]="shipperConfigForm">
      <ion-row class="wrapper ion-margin-bottom ion-margin-top">
        <ion-col size="auto">
          <div class="form-group small-input-group">
            <app-form-text-field
              [labelText]="'Code'"
              [form]="shipperConfigForm"
              [control]="'code'"
              [hasRequiredSign]="false"
            ></app-form-text-field>
          </div>
        </ion-col>
        <ion-col size="auto">
          <div class="form-group small-input-group">
            <app-form-text-field
              [labelText]="'Shipper ID'"
              [form]="shipperConfigForm"
              [control]="'shipperId'"
              [hasRequiredSign]="false"
            ></app-form-text-field>
          </div>
        </ion-col>
        <ion-col size="auto" class="pl-10">
          <div class="form-group timezone-input-group select-form-group">
            <app-form-select
              [label]="CONSTANTS.TIMEZONE"
              [options]="timezoneOptionList"
              formControlName="timeZoneID"
            >
            </app-form-select>
          </div>
        </ion-col>
      </ion-row>
      <ion-row class="wrapper ion-margin-bottom">
        <ion-col size="auto">
          <div class="form-group small-input-group">
            <app-form-text-field
              [labelText]="'Origin Country'"
              [form]="shipperConfigForm"
              [control]="'origCountry'"
              [hasRequiredSign]="false"
            ></app-form-text-field>
          </div>
        </ion-col>
        <ion-col size="auto">
          <div class="form-group small-input-group">
            <app-form-text-field
              [labelText]="'Origin Slic'"
              [form]="shipperConfigForm"
              [control]="'origSlic'"
              [hasRequiredSign]="false"
            ></app-form-text-field>
          </div>
        </ion-col>
        <ion-col size="3" class="">
          <!-- Destination Sort -->
          <app-form-select
            [label]="CONSTANTS.ORIGIN_SORT"
            [options]="sortOptions"
            [formControlName]="'origSort'"
            [required]="false"
            [isAppendToBody]="true"
          >
          </app-form-select>
        </ion-col>
      </ion-row>
      <ion-row class="wrapper ion-margin-bottom">
        <ion-col size="auto">
          <div class="form-group">
            <app-form-text-field
              [labelText]="'Dest Bldg Mnemonic'"
              [form]="shipperConfigForm"
              [control]="'destMnemonic'"
              [hasRequiredSign]="false"
            ></app-form-text-field>
          </div>
        </ion-col>
        <ion-col size="auto">
          <div class="form-group">
            <app-form-text-field
              [labelText]="'Destination Country'"
              [form]="shipperConfigForm"
              [control]="'destCountry'"
              [hasRequiredSign]="false"
            ></app-form-text-field>
          </div>
        </ion-col>
        <ion-col size="auto">
          <div class="form-group small-input-group">
            <app-form-text-field
              [labelText]="'Dest Slic'"
              [form]="shipperConfigForm"
              [control]="'destSlic'"
              [hasRequiredSign]="false"
            ></app-form-text-field>
          </div>
        </ion-col>
        <ion-col size="auto" class="">
          <!-- Destination Sort -->
          <app-form-select
            [label]="CONSTANTS.DESTINATION_SORT"
            [options]="sortOptions"
            [formControlName]="'destSort'"
            [required]="false"
            [isAppendToBody]="true"
          >
          </app-form-select>
        </ion-col>
        <ion-col size="auto" class="">
          <!-- Service Level -->
          <app-form-select
            [label]="CONSTANTS.SERVICE_LEVEL"
            [options]="serviceLevelOptions"
            [formControlName]="'srvLevel'"
            [required]="false"
            [isAppendToBody]="true"
          >
          </app-form-select>
        </ion-col>
      </ion-row>
      <ion-row class="wrapper ion-margin-bottom">
        <ion-col size="auto">
          <div class="form-group small-input-group">
            <app-form-text-field
              [labelText]="'PKG Loc Role'"
              [form]="shipperConfigForm"
              [control]="'pkgLocRole'"
              [hasRequiredSign]="false"
            ></app-form-text-field>
          </div>
        </ion-col>
        <ion-col size="auto">
          <div class="form-group small-input-group">
            <app-form-text-field
              [labelText]="'Disposition'"
              [form]="shipperConfigForm"
              [control]="'disposition'"
              [hasRequiredSign]="false"
            ></app-form-text-field>
          </div>
        </ion-col>
        <ion-col size="auto">
          <div class="form-group small-input-group">
            <app-form-text-field
              [labelText]="'PKG Capacity'"
              [form]="shipperConfigForm"
              [control]="'pkgCapacity'"
              [hasRequiredSign]="false"
            ></app-form-text-field>
          </div>
        </ion-col>
      </ion-row>
      <ion-row class="wrapper ion-margin-bottom">
        <ion-col size="auto">
          <div class="form-group small-input-group">
            <app-form-text-field
              [labelText]="'Belt'"
              [form]="shipperConfigForm"
              [control]="'belt'"
              [hasRequiredSign]="false"
            ></app-form-text-field>
          </div>
        </ion-col>
        <ion-col size="auto">
          <div class="form-group small-input-group">
            <app-form-text-field
              [labelText]="'Bay'"
              [form]="shipperConfigForm"
              [control]="'bay'"
              [hasRequiredSign]="false"
            ></app-form-text-field>
          </div>
        </ion-col>
        <ion-col size="auto">
          <div class="form-group small-input-group">
            <app-form-text-field
              [labelText]="'Scan User'"
              [form]="shipperConfigForm"
              [control]="'scanUser'"
              [hasRequiredSign]="false"
            ></app-form-text-field>
          </div>
        </ion-col>
      </ion-row>
    </form>
    <ion-row class="add-ftp-row ion-justify-content-end">
      <ion-col size="auto">
        <ion-button class="add-btn" (click)="onSubmit()">
          <span class="text">Submit</span>
        </ion-button>
      </ion-col>
    </ion-row>
  </div>
</ion-card>
